export default __webpack_public_path__ + "static/media/entenda_1_frente.7b76c79f.jpg";